import App from './App';
import authenticationRoutes from './features/authentication/routes';
import {Authorize} from './features/authentication/containers';
import characterDetailRoutes from './features/characterDetail/routes';
import communityRoutes from './features/community/routes';
import {DashboardPage} from './features/dashboard/containers';
import dashboardRoutes from './features/dashboard/routes';
import introductionRoutes from './features/introduction/routes';
import lessonDetailRoutes from './features/lessonDetail/routes';
import libraryRoutes from './features/library/routes';
import newCommunityPostRoutes from './features/newCommunityPost/routes';
import passwordManagementRoutes from './features/passwordManagement/routes';
import React from 'react';
import sharedRoutes from './features/shared/routes';
import stateMandateRoutes from './features/stateMandates/routes';
import userProfileRoutes from './features/userProfile/routes';
import usersRoutes from './features/users/routes';
import {IndexRoute, Route} from 'react-router';

export default (
  <Route path="/" component={App}>
    <Route component={Authorize}>
      <IndexRoute component={DashboardPage} />
      {characterDetailRoutes}
      {communityRoutes}
      {dashboardRoutes}
      {lessonDetailRoutes}
      {introductionRoutes}
      {libraryRoutes}
      {newCommunityPostRoutes}
      {userProfileRoutes}
      {usersRoutes}
      {stateMandateRoutes}
    </Route>
    {authenticationRoutes}
    {passwordManagementRoutes}
    {sharedRoutes}
  </Route>
);



// WEBPACK FOOTER //
// ./app/routes.js